<app-list-table-crud [tableArray]="tableArray" [tableRelations]="tableRelations" [TableName]="TableName" [Atributos]="Atributos"></app-list-table-crud>